module.exports = __webpack_public_path__ + "img/landing_content_example_2.ae4a5c78.jpg";